import React, { useState } from 'react';
import EpisodeOfCareRecord from './EpisodeOfCareRecord';
import { AppointmentDetails } from '../dialogs/EpisodeOfCareDetails';

const AppointmentRecord = ({ appointment, ...props }) => {
  const [visible, setVisible] = useState(false);
  const handleAppointmentClick = () => {
    setVisible(true);
  };
  const handleDialogClose = () => setVisible(false);

  return (
    <>
      <AppointmentDetails
        appointment={appointment}
        visible={visible}
        onCancel={handleDialogClose}
      />
      <EpisodeOfCareRecord
        record={appointment}
        {...props}
        onClick={handleAppointmentClick}
      />
    </>
  );
};

export default AppointmentRecord;
